import styled from 'styled-components';

const BreakAvoidWrapper = styled.div`
  page-break-inside: avoid !important;
  break-inside: avoid !important;
  position: relative;
`;

export default BreakAvoidWrapper;
